import {PerfilUsuarioModel} from "@/models/seguridad/perfil-usuario";
import PerfilUsuarioAPI from "@/services/seguridad/perfilUsuario";
import * as R from "ramda";
import {scrollToForm} from '@/helpers/form-scroll-to';

function evaluateModelChangedFlag(data){
  if(!data && typeof data === "boolean") return data
  if(data && typeof data === "object") return data.length>=1;
}
const modelIsModified = R.curry((mod)=>R.compose(evaluateModelChangedFlag,mod.changed)());

//Base State
function BaseStateForm(){}
// States' consctructors
export function InitialState(self){
  //Assing contethis.data = self;xt
  this.data = self;
  //Reset Models and validators
  this.resetModel();
  this.resetValidators();
  //View configuration
  this.data.view.elem.button.audit.visible=true;     
}
export function EditingState(self, perfilUsuario){
  this.data = self;
  const {username, foto} = perfilUsuario;
  this.data.view.elem.button.audit.visible=true;
  this.data.perfilUsuario = new PerfilUsuarioModel({username, foto});
  this.resetValidators();
}
export function SavedState(self, {username, foto}){}
// Setting Base as prototype
InitialState.prototype = Object.create(BaseStateForm.prototype);
EditingState.prototype = Object.create(BaseStateForm.prototype);
SavedState.prototype   = Object.create(BaseStateForm.prototype);
// Setting his own constructor instead of constructor's prototype
InitialState.prototype.constructor = InitialState;
EditingState.prototype.constructor = EditingState;
SavedState.prototype.constructor   = SavedState;
//Base skeleton

BaseStateForm.prototype.edit   = function(){console.log("edit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.submit = function(){console.log("submit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.resetModel = function(){this.data.perfilUsuario = new PerfilUsuarioModel();}
BaseStateForm.prototype.resetValidators = function(){this.data.$v.$reset();}
BaseStateForm.prototype.isDisableButtonSubmit = function(){return this.data.hasErrors(this.data.$v.perfilUsuario)|| this.data.view.action.submit.busy}

//Editing State Implementation
EditingState.prototype.submit = async function(perfilUsuario){
  let {username, foto}=perfilUsuario;
  try{
    if(!this.data.isAllValid(this.data.$v)){
      scrollToForm(this.data);
      return false;
    }
    this.data.view.action.submit.busy=true;

    
    const response = await PerfilUsuarioAPI.update({username, foto}); 
    this.data.view.action.submit.busy=false;
    Object.setPrototypeOf(this.data.state, new InitialState(this.data));
    Object.setPrototypeOf(this.data.state, new EditingState(this.data,perfilUsuario));
    return response;
  }catch(error){
    console.log(error)
    return error;
  }
}
EditingState.prototype.isDisableButtonSubmit = function(){
  this.data.$v.perfilUsuario.$touch()
  return this.data.hasErrors(this.data.$v.perfilUsuario) 
    || this.data.view.action.submit.busy
    || !modelIsModified(this.data.perfilUsuario)
}
//Saved State Implementation




// WEBPACK FOOTER //
// ./src/views/seguridad/perfilUsuario/perfil-usuario-states.js